<template>
  <img
    v-if="src"
    :src="src"
    :class="classOverride || 'svg-color'"
    alt="icon"
    @error="onImageLoadFailed"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  classOverride?: string;
  item: {
    icon?: string;
    key: string;
    namespace: string;
  };
}>();

const { getSrc, fallback } = useTaskIcon();
const src = ref(getSrc(props.item.key, props.item.icon));

function onImageLoadFailed() {
  src.value = fallback;
}
</script>
